var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import classNames from "classnames";
import { Button } from "./Button";
import { animatedBtnCls, animatedBtnTransparentCls, animatedBtnSemitransparentCls, animatedBtnLabeledCls } from "./Animated.less";
var TYPE_TO_CLASSNAME = {
  transparent: animatedBtnTransparentCls,
  semitransparent: animatedBtnSemitransparentCls
};
var AnimatedButton = /* @__PURE__ */ __name(function AnimatedButton2(_ref) {
  var type = _ref.type, className = _ref.className, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, onClick = _ref.onClick, icon = _ref.icon, title = _ref.title;
  return /* @__PURE__ */ React.createElement(Button, _extends({
    className: classNames(animatedBtnCls, type && TYPE_TO_CLASSNAME[type], _defineProperty({}, animatedBtnLabeledCls, !!children), className),
    type: children ? "link" : "ghost",
    size: "medium",
    icon,
    onClick
  }, !children ? {
    shape: "circle"
  } : null, children ? {
    linkType: "light"
  } : null, title ? {
    title
  } : null), children);
}, "AnimatedButton");
export {
  AnimatedButton
};
